import { render } from "./DialogBase.vue?vue&type=template&id=402c7c0f"
import script from "./DialogBase.vue?vue&type=script&lang=js"
export * from "./DialogBase.vue?vue&type=script&lang=js"

import "./DialogBase.vue?vue&type=style&index=0&id=402c7c0f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__